module.exports = __webpack_public_path__ + "img/no_image.eb23042d.jpg";